import { useAtomValue } from 'jotai'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import CollectionNotificationListPublic from '@/components/collection-notification/list-public'
import { selectedMunicipalityIdAtom } from '@/state'

function CollectionNotificationView() {

    const title = 'Upozornění ke svozu'

    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper>
                <Typography variant="h2" component="h1" gutterBottom>
                    {title}
                </Typography>
                {municipalityId ?
                    <CollectionNotificationListPublic />
                    :
                    <Box>
                        Vyberte prosím konkrétní obec výše.
                    </Box>
                }
                
            </CustomPaper>
        </>
    )
}

export default CollectionNotificationView
